import {ModalM} from "@common/components/modal/ModalM";
import React from "react";
import AvatarImageCropper from "react-avatar-image-cropper/src";

export function ImagePickerCropModal({isOpen, handleShowModal, apply}) {

    return <ModalM visible={isOpen}
                   onDismiss={handleShowModal}
                   style={{
                       width: 340,
                       height: 380,
                       maxHeight: "80%"
                   }}>
        <AvatarImageCropper apply={(file) => {
            apply(file)
            handleShowModal()
        }}
                            textStyle={{
                                fontFamily: "Montserrat-Regular",
                            }}
                            text={"Choisir une image"}
                            rootStyle={{
                                width: 300,
                                height: 300,
                                borderRadius: 150,
                                margin: '0 auto'
                            }}
                            sliderConStyle={{
                                position: 'relative',
                                top: 0,
                                zIndex: 9,
                                backgroundColor: '#222',
                                display: 'flex',
                                justifyContent: 'center',
                                borderRadius: '0 0 10px 10px'
                            }}/>
    </ModalM>;
}